module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100 align-items-end",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [(!_vm.isCreatingSingleEvent) ? _c('span', {
    staticClass: "font-weight-600 pointer color-6",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v("\n            Delete\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary px-5",
    attrs: {
      "disabled": _vm.getIsUpdatingEvent
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn success px-5",
    attrs: {
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges(false)
      }
    }
  }, [_vm._v("Save")]), (_vm.isCreatingSingleEvent) ? _c('button', {
    staticClass: "btn success px-5",
    attrs: {
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges(true)
      }
    }
  }, [_vm._v("Save & Book")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2f6bc9e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f6bc9e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/footerButtons.vue
// module id = 1459
// module chunks = 0